module.exports = __webpack_public_path__ + "static/media/reporte2015-16.9a58c306.png";